'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analyzeDateRange = analyzeDateRange;
exports.formatted = formatted;
exports.ymdDate = ymdDate;
var strftime = require('strftime');
var locales = require('../shared/locales').locales;
var timeZones = require('../shared/timeZones').timeZones;
var moment = require('moment-timezone');

function _getStrftime(tz, lc, epoch) {
  var match = (tz || '').match(/^(America|US)\/(.*)/) || [];
  var defaultOffset = function defaultOffset() {
    return timeZones['America/' + match[2]] || timeZones['US/' + match[2]] || timeZones[tz] || null;
  };
  var mZone = moment.tz.zone('America/' + match[2]) || moment.tz.zone('US/' + match[2]) || moment.tz.zone(tz) || null;
  var offset = mZone ? mZone.offset(epoch) * -1 : defaultOffset();

  return strftime.localize(locales[lc]).timezone(offset);
}

function _dateFromEpoch(epoch) {
  return epoch ? new Date(epoch * 1000) : new Date(null);
}

function analyzeDateRange(startEpoch, endEpoch, timeZone, lc) {
  var strf = _getStrftime(timeZone, lc);
  var start = strf('%Y %m %d', _dateFromEpoch(startEpoch)).split(' ');
  var end = endEpoch ? strf('%Y %m %d', _dateFromEpoch(endEpoch)).split(' ') : null;

  var dayDiffers = end === null ? false : start[2] !== end[2];
  var monthDiffers = end === null ? false : start[1] !== end[1];
  var yearDiffers = end === null ? false : start[0] !== end[0];

  return {
    isRange: dayDiffers || monthDiffers || yearDiffers,
    dayDiffers: dayDiffers,
    monthDiffers: monthDiffers,
    yearDiffers: yearDiffers
  };
}

function formatted(epoch, format, timeZone, lc) {
  var strf = _getStrftime(timeZone, lc, epoch * 1000);
  return epoch ? strf(format || '%D', _dateFromEpoch(epoch)) : null;
}

function ymdDate(epoch, format, timeZone, lc) {
  return formatted(epoch, format, timeZone, lc);
}

var dateUtils = exports.dateUtils = {
  analyzeDateRange: analyzeDateRange,
  formatted: formatted,
  ymdDate: ymdDate
};


//////////////////
// WEBPACK FOOTER
// ../~/bastetjs/lib/utils/dateUtils.js
// module id = 473
// module chunks = 0